import { ModelBase, Property, Required } from '@skylab-shared/core';
import { KsefSendParametersSalePatternSendMode } from './ksef-send-parameters-sale-pattern-send-mode';
import { KsefSendSubmissionMode } from './ksef-send-submission-mode';

export class KsefSendParametersModel extends ModelBase {
	@Property({ identifiable: true })
	public id: number;

	@Property()
	public sendDocumentNote: boolean;

	@Property()
	public sendWzNumbers: boolean;

    @Property()
	public sendSymbolAsIndeks: boolean;

    @Property()
	public sendBarCodeAsGTIN: boolean;

	@Property()
	@Required()
	public documentTemplateSendMode: KsefSendParametersSalePatternSendMode;

	@Property()
	@Required()
	public defaultDocumentType: KsefSendSubmissionMode;
}
